const API_URL = import.meta.env.VITE_API_URL || '';

// Global auth token storage
let currentAuthToken: string | undefined;
let currentWalletAddress: string | undefined;

export function setGlobalAuthToken(token: string | undefined) {
  currentAuthToken = token;
}

export function setGlobalWalletAddress(address: string | undefined) {
  currentWalletAddress = address;
}

export function getGlobalWalletAddress(): string | undefined {
  return currentWalletAddress;
}

export function getGlobalAuthToken(): string | undefined {
  return currentAuthToken;
}

export async function apiRequest(
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  endpoint: string,
  body?: any,
  token?: string
) {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  };

  // Use provided token or fall back to global token
  const authToken = token || currentAuthToken;
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  const response = await fetch(`${API_URL}${endpoint}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || error.message || 'Request failed');
  }

  return response.json();
}

export function getApiUrl(): string {
  return API_URL;
}
